import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateService } from '../services/date.service';
import { base64StringToBlob } from 'blob-util';
import { EditorComponent } from '../editor/editor.component';
// Angular Editor Supprimer
// import { AngularEditorConfig } from '@kolkov/angular-editor';
declare var $: any;
@Component({
  selector: 'app-avt-echange',
  templateUrl: './avt-echange.component.html',
  styleUrls: ['./avt-echange.component.scss'],
})
export class AvtEchangeComponent implements OnInit {
  constructor(
    public dateService: DateService,
    public route: ActivatedRoute,
    public generalService: GeneralService,
    public dialogRef: MatDialogRef<AvtEchangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
  // Angular Editor Supprimer
  // editorConfig: AngularEditorConfig = this.generalService.editorConfig;
  echange;
  CRMActivity_Type = this.generalService.sort(
    [
      { type_texte: 'Téléphone', type_value: 'call_end' },
      { type_texte: 'E-mail', type_value: 'alternate_email' },
      { type_texte: 'Rencontre', type_value: 'group' },
      { type_texte: 'Courrier', type_value: 'mail' },
    ],
    'type_texte'
  );
  CRMActivity;
  exist: boolean = true;
  dsabledBtnEnregister: boolean = false;
  imageName: string = '';
  imageType: string = '';
  imageSrc: string = '';
  haveFile: boolean = false;
  fileEchange;
  selectedFile: number;
  listeFile = [];
  datasourceInterlocuteur = [];
  configInfoBasPage = { height: 120 };
  @ViewChild('editor', { static: false }) editor: EditorComponent;
  ngOnInit() {
    this.echange = {};
    this.getRecD();
    this.getDataInterlocuteur();
  }
  getDataInterlocuteur() {
    this.generalService
      .rechercheTable(
        this.generalService.urlListeInterlocuteur + this.data.Tiers_code
      )
      .subscribe((data) => {
        this.datasourceInterlocuteur = this.generalService.sort(
          data,
          'TiersC_Nom'
        );
      });
  }
  getRecD() {
    if (this.data.CRMActivity_Id == '-1')
      var url = this.generalService.urlCrmactivity;
    else {
      var url =
        this.generalService.urlCrmactivity + '&val=' + this.data.CRMActivity_Id;
      //this.getFile()
    }
    this.generalService.rechercheTable(url).subscribe((rec) => {
      this.CRMActivity = rec;
      this.echange = this.CRMActivity.CRMActivity[0];
      this.editor.setHTML(this.echange.CRMActivity_Description);
    });
  }
  enregistrer(f) {
    if (f.form.valid) {
      if (this.generalService.userPerso.UserName) {
        this.exist = false;
        this.dsabledBtnEnregister = true;
        this.echange.CRMActivity_Date =
          this.dateService.setToFormatDateServerStr(new Date());
        this.echange.User_Id = this.generalService.userPerso.UserName;
        this.echange.Tiers_code = this.data.Tiers_code;
        this.generalService.enregisterTable(this.CRMActivity).subscribe(
          (rec) => {
            //l'echange à un document à enregistrer
            if (this.imageName != '') {
              //mode ajouter
              if (this.data.CRMActivity_Id == '-1')
                if (rec.code != '') this.addFiles(rec.code);
                else {
                  alert(
                    "échange enregistrer mais le document n'est pas enregistrer"
                  );
                  this.dialogRef.close({ status: true });
                }
              //mode modifier
              else this.addFiles(this.data.CRMActivity_Id);
            } else this.dialogRef.close({ status: true });
          },
          (error) => {
            this.dialogRef.close({ status: false });
          }
        );
      }

      // if()
      // this.addFiles()
    }
  }
  close() {
    this.dialogRef.close({ status: false });
  }
  onChangeImagefile(fileInput) {
    var reader2 = new FileReader();
    var src: string;
    reader2.onload = (e) => {
      src = reader2.result.toString();
      this.imageName = fileInput.target.files[0].name;
      this.imageType = src.substring(0, src.indexOf(',') + 1);
      this.imageSrc = src.replace(this.imageType, '');
    };
    reader2.readAsDataURL(fileInput.target.files[0]);
  }
  selectFile(id: number) {
    this.selectedFile = id;
    for (var i = 0; i < this.listeFile.length; i++) {
      $('#' + this.listeFile[i].File_Id).attr('style', '');
    }
    $('#' + id).attr('style', 'border-color: blue;   border-style: solid;');
  }
  addFiles(CRMActivity_Id) {
    var initDoc = this.generalService.initDoc;
    initDoc.files[0].File_Content = this.imageSrc;
    initDoc.files[0].File_Text = this.imageName;
    initDoc.files[0].File_Key = CRMActivity_Id;
    initDoc.files[0].File_Type = 'echange';
    initDoc.files[0].File_Groupe = this.data.type;
    initDoc.files[0].File_Lien = '';
    initDoc.files[0].File_Autre = this.imageType;
    initDoc.files[0].File_Dll = 'jstree-file';
    this.generalService.enregisterTable(initDoc).subscribe(
      (data) => {
        this.dialogRef.close({ status: true });
      },
      (err) => {
        this.dialogRef.close({ status: false });
      }
    );
  }
  getFile() {
    this.generalService
      .rechercheTable(
        this.generalService.urlFindDoc +
          this.data.CRMActivity_Id +
          ',' +
          'echange' +
          ',' +
          this.data.type
      )
      .subscribe(
        (data) => {
          this.listeFile = data;
          if (
            this.listeFile != undefined &&
            this.listeFile != null &&
            this.listeFile.length > 0
          ) {
            this.haveFile = true;
          }
        },
        (err) => {}
      );
  }
  telecharger() {
    const blob = base64StringToBlob(
      this.fileEchange[this.fileEchange.length - 1].File_Content,
      this.fileEchange[this.fileEchange.length - 1].File_Autre
    );
    var fileURL = URL.createObjectURL(blob);
    window.URL.revokeObjectURL(fileURL);
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(
        blob,
        this.fileEchange[this.fileEchange.length - 1].File_Text
      );
      return;
    }
    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute(
      'download',
      this.fileEchange[this.fileEchange.length - 1].File_Text
    );

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    setTimeout(() => {
      window.URL.revokeObjectURL(blobURL);
    }, 100);
  }
  importer(id) {
    document.getElementById('input_' + id).click();
  }

  editorAction(event) {
    if ((event.action = 'editor-change')) {
      this.echange.CRMActivity_Description = event.editor.getHTML();
    }
  }
}
